//imports
import {
    ACCOUNTS_GET_ACCOUNT_OPEN_MODAL,
    ACCOUNTS_GET_ACCOUNT_REQUEST,
    ACCOUNTS_GET_ACCOUNT_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    account: null,
    loading: false,
    result: null,
    openModal: false
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case ACCOUNTS_GET_ACCOUNT_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, account: action.payload.account }

        case ACCOUNTS_GET_ACCOUNT_REQUEST:
            return { ...state, loading: true }

        case ACCOUNTS_GET_ACCOUNT_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "ACCOUNTS_DETAILS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};